import React from 'react';
import { MapPin, Phone, Linkedin, Mail, HelpCircle, ArrowRight } from 'lucide-react';

const Contact = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Get in touch with our team
            </h1>
            <p className="text-xl text-gray-600">
              Connect with our experts to explore how we can optimize your rail operations and enhance your logistics efficiency.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-8">Contact Information</h2>
            <div className="space-y-8">
              <div className="flex items-center space-x-4">
                <Phone className="h-8 w-8 text-blue-600" />
                <div>
                  <p className="font-medium text-lg">Phone</p>
                  <p className="text-gray-600 text-lg">(888) 275-2775</p>
                  <p className="text-sm text-gray-500 mt-1">Monday - Friday, 8:00 AM - 6:00 PM MT</p>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <Mail className="h-8 w-8 text-blue-600" />
                <div>
                  <p className="font-medium text-lg">Sales & General Inquiries</p>
                  <a href="mailto:sales@geometrix.com" className="text-blue-600 hover:text-blue-700 transition-colors">
                    sales@geometrix.com
                  </a>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <HelpCircle className="h-8 w-8 text-blue-600" />
                <div>
                  <p className="font-medium text-lg">Product Support</p>
                  <a href="mailto:help@geometrix.com" className="text-blue-600 hover:text-blue-700 transition-colors">
                    help@geometrix.com
                  </a>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <MapPin className="h-8 w-8 text-blue-600" />
                <div>
                  <p className="font-medium text-lg">Headquarters</p>
                  <p className="text-gray-600">Calgary, AB (Canada)</p>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <Linkedin className="h-8 w-8 text-blue-600" />
                <div>
                  <p className="font-medium text-lg">Connect with us</p>
                  <a 
                    href="https://www.linkedin.com/company/geometrix-rail-logistics"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-700 transition-colors"
                  >
                    GeoMetrix
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Ready to transform your rail operations?</h2>
          <p className="text-xl text-gray-600 mb-8">
            Our team is ready to help you optimize your logistics processes
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a 
              href="tel:8882752775"
              className="inline-flex items-center justify-center bg-blue-600 text-white font-bold py-4 px-8 rounded-md hover:bg-blue-700 transition-colors"
            >
              <Phone className="h-5 w-5 mr-2" />
              (888) 275-2775
            </a>
            <a 
              href="mailto:sales@geometrix.com"
              className="inline-flex items-center justify-center bg-gray-800 text-white font-bold py-4 px-8 rounded-md hover:bg-gray-900 transition-colors"
            >
              <Mail className="h-5 w-5 mr-2" />
              sales@geometrix.com
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;